import { createFeatureSelector } from '@ngrx/store';
import { PointsMultiplierCreateUpdateState } from '../models/points-multiplier.model';
import { RegistrationPointsCreateUpdateState } from '../models/registration-points.model';
import { SearchRecipesState } from '../models/search.model';
import { SharedState } from '../models/shared.model';
import { PointsMultiplierCreateUpdateReducer } from './points-multiplier.reducer';
import { RegistrationPointsCreateUpdateReducer } from './registration-points.reducer';
import { SearchRecipesReducer } from './search.reducer';
import { SharedReducer } from './shared.reducer';

export const featureRecipesName = 'Recipes';

export interface DragonflyRewardRulesState {
  search: SearchRecipesState;
  shared: SharedState;
  pointsMultiplierCreateUpdate: PointsMultiplierCreateUpdateState;
  registrationPointsCreateUpdate: RegistrationPointsCreateUpdateState;
}

export const moduleRecipeReducers = {
  search: SearchRecipesReducer,
  shared: SharedReducer,
  pointsMultiplierCreateUpdate: PointsMultiplierCreateUpdateReducer,
  registrationPointsCreateUpdate: RegistrationPointsCreateUpdateReducer,
};

export const getDragonflyRecipesState =
  createFeatureSelector<DragonflyRewardRulesState>(featureRecipesName);
